import React, { Fragment } from 'react';
import FileExplorerHeader from './FileExplorerHeader';
import FileItem from './FileItem';
import { Spinner, Table } from 'react-bootstrap';
import './FileExplorer.scss';

const FileExplorer = ({
    files,
    isLoading,
    isFileOver,
    onSortClick,
    selectedFiles,
    onAllFilesChecked,
    onFileChecked,
}) => {
    return (
        <Fragment>
            <div className="rounded shadow bg-white table-container">
                <Table className="rounded mb-0">
                    <FileExplorerHeader
                        onSortClick={onSortClick}
                        onAllFilesChecked={onAllFilesChecked}
                        isAllFilesChecked={
                            selectedFiles.length === files.length &&
                            selectedFiles.length > 0
                        }
                    />
                    <tbody>
                        {files.length > 0 && !isLoading && (
                            <>
                                {files.map((element) => (
                                    <FileItem
                                        key={element.id}
                                        element={element}
                                        onCheckItem={onFileChecked}
                                        isSelected={selectedFiles
                                            .map((file) => file.id)
                                            .includes(element.id)}
                                    />
                                ))}
                            </>
                        )}
                    </tbody>
                </Table>
                {isLoading && (
                    <div
                        className="d-flex justify-content-center loader-icon"
                        style={{ paddingTop: 40, paddingBottom: 40 }}
                    >
                        <Spinner color={'inherit'} />
                    </div>
                )}
                {files.length === 0 && !isLoading && (
                    <div className="d-flex justify-content-center text-center opacity-50">
                        <p className="my-4">
                            No file available in this directory
                        </p>
                    </div>
                )}
            </div>
        </Fragment>
    );
};

export default FileExplorer;
